import { Avatar, Group, Text, UnstyledButton } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import React from 'react';
import { MyUser } from '../../global';
import { useAppSelector as useSelector } from '../../hooks/ReduxHooks';

export const UserButton = ({onClick}:{onClick:()=>void}) => {
    const img:string= useSelector(state => state.auth.picture);
    // console.log(pic)
    const user:MyUser= useSelector(state => state.auth.user);
    const name = user.name
    const email = user.email
    return (
        <UnstyledButton onClick={onClick}>
            <Group>
                { img != "" ? <Avatar src={img} radius="xl" /> : null }
                <div style={{ flex: 1 }}>
                    <Text size="sm" fw={500}>{name}</Text>
                    <Text c="dimmed" size="xs">{email}</Text>
                </div>
                <IconChevronRight size={14} stroke={1.5} />
            </Group>
        </UnstyledButton>
    );
}